module.exports = __webpack_public_path__ + "static/media/book-cover-faith2.4ae9219e.jpg";